/* Progressive enhancement: all product copy remains visible if scripting is unavailable. */
if (!customElements.get('cc-product-details')) {
  customElements.define('cc-product-details', class extends HTMLElement {
    connectedCallback() {
      requestAnimationFrame(() => this.enhance());
    }
    enhance() {
      if (this.dataset.enhanced === 'true') return;
      this.dataset.enhanced = 'true';
      const titles = new Set(['transparency', 'use & safety', 'care & reuse']);
      const normalize = (value) => value.trim().toLowerCase().replace(/\s+/g, ' ');
      const essentials = document.createElement('ul');
      essentials.className = 'cc-product-essentials';
      this.querySelectorAll('.cc-transparency li, .cc-transparency > p').forEach((item) => {
        const label = normalize(item.querySelector('strong')?.textContent || '');
        if (/^(what you receive|power):?$/.test(label) || /\b(size|sizes|dimensions|fit)\b/.test(label) || (/^what we haven.t verified:?$/.test(label) && /power/i.test(item.textContent))) {
          if (item.tagName === 'LI') essentials.append(item.cloneNode(true));
          else { const entry = document.createElement('li'); [...item.childNodes].forEach(child => entry.append(child.cloneNode(true))); essentials.append(entry); }
        }
      });
      const warnings = document.createElement('ul');
      warnings.className = 'cc-product-key-warnings';
      this.querySelectorAll('li').forEach((item) => {
        const label = normalize(item.querySelector('strong')?.textContent || '');
        if (/^(use and safety|age or fit):?$/.test(label) && /supervis|chok|small parts|button batter|coin cell|open flame|flammable|not for children|under 3|not for tethering/i.test(item.textContent)) {
          warnings.append(item.cloneNode(true));
        }
      });
      let firstDetails;
      [...this.children].forEach((node) => {
        let heading, nodes = [];
        if (node.matches('section')) {
          heading = node.querySelector(':scope > h2, :scope > h3');
          if (!heading || !titles.has(normalize(heading.textContent))) return;
          nodes = [...node.childNodes].filter((child) => child !== heading);
        } else if (node.matches('h2,h3') && titles.has(normalize(node.textContent))) {
          heading = node;
          let next = node.nextSibling;
          while (next && !(next.nodeType === 1 && next.matches('h2,h3,section,details'))) {
            nodes.push(next);
            next = next.nextSibling;
          }
        } else return;
        const details = document.createElement('details');
        details.className = 'cc-product-detail-row';
        const summary = document.createElement('summary');
        const label = document.createElement('span');
        label.textContent = heading.textContent;
        summary.append(label);
        const content = document.createElement('div');
        content.className = 'cc-product-detail-content';
        nodes.forEach((child) => content.append(child));
        details.append(summary, content);
        node.replaceWith(details);
        if (!firstDetails) firstDetails = details;
      });
      if (firstDetails && essentials.children.length) firstDetails.before(essentials);
      if (firstDetails && warnings.children.length) firstDetails.before(warnings);
    }
  });
}
